import { Component, inject } from '@angular/core';

import { NewAccountComponent } from '../new-account.component';

@Component({
  selector: 'app-new-account-desktop-view',
  templateUrl: './new-account-desktop-view.component.html',
  styleUrls: ['../shared-styles/new-account-device-view.component.scss'],
  standalone: false,
})
export class NewAccountDesktopViewComponent {
  public readonly newAccount = inject(NewAccountComponent);
}
